import React from "react";
import styles from "./OfferTableControls.module.css";
import {SearchField} from "../../../../elements/searchField/SearchField";
import {
    MultiSelectTableFilterDropdown
} from "../../../../elements/multiSelectTableFilter/MultiSelectTableFilterDropdown";
import {OfferType} from "../../../../../api/generated";
import {BroomButton} from "../../../../elements/broomButton/BroomButton";
import {useAppDispatch, useAppSelector} from "../../../../../app/hooks";
import {
    defaultOfferTableRequestRequest,
    offerMakeOptionsSelector,
    offerModelOptionsSelector,
    offerOptionsRequestStatusSelector,
    offerSourceNameOptionsSelector,
    offerTableRequestSelector,
    resetOfferTableRequest,
    updateOfferTableRequest
} from "../../offerListSlice";
import {allOfferTypeOptions} from "../../modal/createAndUpdate/components/util/offerTypeUtil";
import {useRequestErrorToast} from "../../../../../hooks/useRequestErrorToast";
import {OfferTypeCard} from "../../../../elements/offerTypeCard/OfferTypeCard";

export const OfferTableControls: React.FC = () => {

    const dispatch = useAppDispatch();
    const offerTableRequest = useAppSelector(offerTableRequestSelector);
    const offerMakeOptions = useAppSelector(offerMakeOptionsSelector);
    const offerModelOptions = useAppSelector(offerModelOptionsSelector);
    const offerSourceNameOptions = useAppSelector(offerSourceNameOptionsSelector);

    useRequestErrorToast(useAppSelector(offerOptionsRequestStatusSelector), "Failed to load offer filter options");

    const resetFilters = () => {
        if (offerTableRequest.searchQuery !== defaultOfferTableRequestRequest.searchQuery ||
            offerTableRequest.offerTypeList !== defaultOfferTableRequestRequest.offerTypeList ||
            offerTableRequest.offerSourceNameList !== defaultOfferTableRequestRequest.offerSourceNameList ||
            offerTableRequest.makeList !== defaultOfferTableRequestRequest.makeList ||
            offerTableRequest.modelList !== defaultOfferTableRequestRequest.modelList) {
            dispatch(resetOfferTableRequest());
        }
    }

    return <div className={styles.wrapper}>
        <div className={styles.controls}>
            <SearchField
                value={offerTableRequest.searchQuery}
                placeholder={'Offer title or description'}
                onChange={newValue => dispatch(updateOfferTableRequest({searchQuery: newValue}))}
            />
            <MultiSelectTableFilterDropdown<OfferType, { offerType: OfferType }>
                value={offerTableRequest.offerTypeList}
                placeholder={"Filter by Offer Type"}
                width={260}
                handleChange={(offerTypeList) => dispatch(updateOfferTableRequest({offerTypeList}))}
                options={allOfferTypeOptions}
                optionComponent={OfferTypeCard}
                getOptionProps={(offerType) => ({offerType})}
            />
            <MultiSelectTableFilterDropdown<string, { make: string }>
                value={offerTableRequest.makeList}
                placeholder={"Filter by Make"}
                width={220}
                handleChange={(makeList) => dispatch(updateOfferTableRequest({makeList}))}
                options={offerMakeOptions}
            />
            <MultiSelectTableFilterDropdown<string, { make: string }>
                value={offerTableRequest.modelList}
                placeholder={"Filter by Model"}
                width={220}
                handleChange={(modelList) => dispatch(updateOfferTableRequest({modelList}))}
                options={offerModelOptions}
            />
            <MultiSelectTableFilterDropdown<string, { offerSourceName: string }>
                value={offerTableRequest.offerSourceNameList}
                placeholder={"Filter by Source"}
                width={220}
                handleChange={(offerSourceNameList) => dispatch(updateOfferTableRequest({offerSourceNameList}))}
                options={offerSourceNameOptions}
            />
        </div>
        <div className={styles.clearButton}>
            <BroomButton disabled={false} handleClick={resetFilters}/>
        </div>
    </div>
}
